/**
 * Calcula el COSTE DE MANO DE OBRA del cortador según el tipo de servicio y el peso.
 * 
 * IMPORTANTE: Estos importes son COSTES DE MANO DE OBRA, NO el precio cobrado al cliente.
 * La facturación al cliente depende de la casuística/tipo de servicio configurado.
 * 
 * NORMAL:              < 10 kg → 20 €  |  >= 10 kg → 25 €
 * EMPLATADO:           siempre 25 €
 * GRANDE_Y_EMPLATADO:  siempre 30 €
 * PALETILLA:           siempre 15 €
 * TUPPER_CON_GRASA:    siempre 30 € (sin envasado al vacío, el cortador añade la grasa)
 *
 * @param {string} tipoGestion - 'NORMAL' | 'EMPLATADO' | 'GRANDE_Y_EMPLATADO' | 'PALETILLA' | 'TUPPER_CON_GRASA'
 * @param {number} peso - Peso inicial de la pieza en kg
 * @returns {number} Coste de mano de obra en euros
 */
export const calcularTarifa = (tipoGestion, peso) => {
  const pesoNum = parseFloat(peso) || 0;
  switch (tipoGestion) {
    case 'EMPLATADO':
      return 25;
    case 'GRANDE_Y_EMPLATADO':
      return 30;
    case 'PALETILLA':
      return 15;
    case 'TUPPER_CON_GRASA':
      return 30;
    case 'NORMAL':
    default:
      return pesoNum < 10 ? 20 : 25;
  }
};

/**
 * Calcula el coste de sala (igual al coste de mano de obra del cortador).
 * @param {string} tipoGestion
 * @param {number} peso
 * @returns {number}
 */
export const calcularCosteSala = (tipoGestion, peso) => {
  return calcularTarifa(tipoGestion, peso);
};

/**
 * Devuelve la descripción textual del coste de mano de obra para mostrar al usuario.
 * @param {string} tipoGestion
 * @param {number} peso
 * @returns {string}
 */
export const getTarifaDescripcion = (tipoGestion, peso) => {
  const tarifa = calcularTarifa(tipoGestion, peso);
  const pesoNum = parseFloat(peso) || 0;
  switch (tipoGestion) {
    case 'EMPLATADO':
      return `Emplatado — coste cortador fijo: ${tarifa} €`;
    case 'GRANDE_Y_EMPLATADO':
      return `Grande y Emplatado — coste cortador fijo: ${tarifa} €`;
    case 'PALETILLA':
      return `Paletilla — coste cortador fijo: ${tarifa} €`;
    case 'TUPPER_CON_GRASA':
      return `Tupper con Grasa — coste cortador fijo: ${tarifa} € (sin envasado al vacío)`;
    case 'NORMAL':
    default:
      return pesoNum < 10
        ? `Normal (${pesoNum?.toFixed(2)} kg < 10 kg) → coste cortador: ${tarifa} €`
        : `Normal (${pesoNum?.toFixed(2)} kg ≥ 10 kg) → coste cortador: ${tarifa} €`;
  }
};

/**
 * Indica si el tipo de servicio requiere trabajador de envasado.
 * TUPPER_CON_GRASA no requiere envasado (el cortador añade la grasa directamente).
 * @param {string} tipoGestion
 * @returns {boolean}
 */
export const requiereEnvasado = (tipoGestion) => {
  return tipoGestion !== 'TUPPER_CON_GRASA';
};
